var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficCongestion = function SvgLiveTrafficCongestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    d: "M12.009 21.352a9.272 9.272 0 1 0 0-18.545 9.272 9.272 0 1 0 0 18.545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21272C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.56,
    d: "M12.009 21.352a9.272 9.272 0 1 0 0-18.545 9.272 9.272 0 1 0 0 18.545Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.748 15.575c-.491-.88-1.01-1.761-1.53-2.652a763.393 763.393 0 0 0-3.727-6.416.588.588 0 0 0-.176-.213c-.26-.195-.603-.084-.779.195-.278.49-.556.964-.844 1.465-1.289 2.215-2.587 4.413-3.857 6.63-.213.342-.408.685-.603 1.028a.488.488 0 0 0 .065.584c.13.149.278.195.473.195h10.487a.81.81 0 0 0 .324-.065c.26-.176.325-.473.149-.75zM12 15.121c-.39 0-.687-.325-.687-.733 0-.39.325-.686.733-.686.39 0 .686.343.686.733a.725.725 0 0 1-.732.686m-.473-2.652V9.001c0-.343.343-.584.667-.454.195.065.325.26.325.473v3.44c0 .306-.213.519-.492.519-.278 0-.491-.213-.491-.52z"
  })));
};
export default SvgLiveTrafficCongestion;